import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Snowflake, LayoutDashboard, ShoppingCart, ShieldCheck, Users, LogOut } from "lucide-react";
import { useState } from "react";

const NAV_ITEMS = [
    { to: "/dashboard", label: "Genel Bakış", icon: LayoutDashboard, testId: "nav-dashboard" },
    { to: "/orders", label: "Sipariş Modülü", icon: ShoppingCart, testId: "nav-orders" },
    { to: "/warranties", label: "Garanti Modülü", icon: ShieldCheck, testId: "nav-warranties" },
];

const ADMIN_NAV = { to: "/users", label: "Kullanıcı Yönetimi", icon: Users, testId: "nav-users" };

const DashboardLayout = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const onLogout = async () => {
        await logout();
        navigate("/login");
    };

    const navItems = user?.role === "admin" ? [...NAV_ITEMS, ADMIN_NAV] : NAV_ITEMS;

    return (
        <div className="min-h-screen bg-white flex" data-testid="dashboard-layout">
            {/* Sidebar */}
            <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-zinc-50 border-r border-zinc-200 flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
                <div className="px-6 py-6 border-b border-zinc-200">
                    <div className="flex items-center gap-2.5">
                        <div className="w-9 h-9 bg-black flex items-center justify-center">
                            <Snowflake className="w-5 h-5 text-white" strokeWidth={1.5} />
                        </div>
                        <div>
                            <div className="font-display font-black tracking-tight leading-none">LC SOĞUTMA</div>
                            <div className="tag-label leading-none mt-1">Bayi Paneli</div>
                        </div>
                    </div>
                </div>

                <nav className="flex-1 px-3 py-6 space-y-0.5">
                    {navItems.map(({ to, label, icon: Icon, testId }) => (
                        <NavLink
                            key={to}
                            to={to}
                            onClick={() => setOpen(false)}
                            data-testid={testId}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 text-sm font-semibold transition-colors ${isActive ? "bg-black text-white" : "text-zinc-700 hover:bg-zinc-200"}`
                            }
                        >
                            <Icon className="w-4 h-4" strokeWidth={1.5} />
                            <span>{label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="px-3 py-4 border-t border-zinc-200">
                    <div className="px-4 py-3 mb-2 bg-white border border-zinc-200">
                        <div className="tag-label mb-1">Oturum</div>
                        <div className="text-sm font-semibold truncate" data-testid="current-user-name">{user?.name}</div>
                        <div className="text-xs text-zinc-500 truncate">@{user?.username} · {user?.role === "admin" ? "Admin" : (user?.role === "uretici" ? "Üretici" : "Bayi")}</div>
                    </div>
                    <button
                        onClick={onLogout}
                        data-testid="logout-button"
                        className="w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-semibold border border-zinc-300 hover:bg-zinc-100 transition-colors"
                    >
                        <LogOut className="w-4 h-4" strokeWidth={1.5} />
                        Çıkış Yap
                    </button>
                </div>
            </aside>

            {/* Mobile overlay */}
            {open && (
                <div
                    onClick={() => setOpen(false)}
                    className="fixed inset-0 z-30 bg-black/40 lg:hidden"
                />
            )}

            {/* Main */}
            <div className="flex-1 flex flex-col min-w-0">
                <header className="lg:hidden flex items-center justify-between px-4 py-3 border-b border-zinc-200 bg-white">
                    <button onClick={() => setOpen(!open)} className="p-2 border border-zinc-300" data-testid="mobile-menu-toggle">
                        <span className="block w-5 h-0.5 bg-black mb-1"></span>
                        <span className="block w-5 h-0.5 bg-black mb-1"></span>
                        <span className="block w-5 h-0.5 bg-black"></span>
                    </button>
                    <div className="font-display font-black tracking-tight">LC SOĞUTMA</div>
                    <div className="w-9" />
                </header>

                <main className="flex-1 overflow-x-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
